import routes from './routes'


const protectedRoutes = ['companies','dashboard','details','officers','officerNew','documents','cbank','accountdetail','accountsadmin','officeradmindetails'];
    routes.beforeEach((to, from, next) => {
        if(protectedRoutes.includes(to.name)){
            if(localStorage.getItem("q_auth")){
              if(localStorage.getItem("orgID")){
                next()
              }else {
                if(to.name === "companies"){
                  next()
                }else{
                  next("/my-companies")
                }
              }
            }else{
              next("/")
            }
        }else{
            next()
        }
  });

  export default routes